import { FPhi } from '@facephi/selphid-widget-web';

export type IdentityDocumentType = 'DNI' | 'PASSPORT'; 

export enum IdentityDocumentCaptureMode {
    DNI = FPhi.SelphID.Mode.Full,
    PASSPORT = FPhi.SelphID.Mode.Front
}